import type LocalStorageBackend from 'i18next-localstorage-backend';
import type { LocalStorageBackendOptions } from 'i18next-localstorage-backend';

const VERSION_STORAGE_KEY = 'i18n:dashboard:version';

export const normalizeVersion = (version: string | null | undefined): string | null => {
  if (typeof version !== 'string' || version.length === 0) return null;
  return version;
};

export const readStoredVersion = (): string | null => {
  try {
    return normalizeVersion(localStorage.getItem(VERSION_STORAGE_KEY));
  } catch {
    return null;
  }
};

export const writeStoredVersion = (version: string): void => {
  try {
    localStorage.setItem(VERSION_STORAGE_KEY, version);
  } catch {
    // intentionally swallowed
  }
};

export const createLocalStorageBackendOptions = (): LocalStorageBackendOptions => {
  const storedVersion = readStoredVersion();
  return {
    defaultVersion: storedVersion ?? undefined
  };
};

export const applyLocalStorageBackendVersion = (backend: LocalStorageBackend, version: string): void => {
  backend.options.defaultVersion = version;
  backend.options.versions = {};
  writeStoredVersion(version);
};

export const invalidateLocalStorageBackendCache = (backend: LocalStorageBackend): void => {
  backend.options.defaultVersion = `cache-miss:${Date.now()}`;
  backend.options.versions = {};
};

export const TEST_KEYS = { VERSION_STORAGE_KEY };
